import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { jsPDF } from "jspdf";
import Logo from '../Logo/White/Full/1Asset 13@72x-8.png';
import Footer2 from "../Footer/Footer2";
import Header1 from "../Header/Header1";




const API_URL = process.env.REACT_APP_API_URL;

function PaymentDetails({ userId, onLogout }) {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);

  const [transactions, setTransactions] = useState([]);
  const [billingDetails, setBillingDetails] = useState({});
  const [sessionDetails, setSessionDetails] = useState([]);


  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);  // State to manage dialog visibility
  const [selectedTransaction, setSelectedTransaction] = useState(null);  // Store selected transaction for viewing the invoice

  const handleViewInvoice = async (transaction) => {
    setSelectedTransaction(transaction);
    setOpenDialog(true);

    // Fetch session details
    try {
      const response = await axios.get(`${API_URL}/api/session-details/`, {
        params: { order_id: transaction.post_id, type: transaction.type },
      });
      setSessionDetails(response.data);
    } catch (err) {
      console.error("Failed to fetch session details", err);
      setSessionDetails(null);
    }

  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    // setTransactions([]);
    setSessionDetails([]);
    // setBillingDetails({});
  };



  useEffect(() => {
    const fetchTransactionsAndBilling = async () => {
      try {
        const response = await axios.post(`${API_URL}/api/transactions/`, {
          user_id: userId,
        });

        // Extract both parts from the response
        const { transactions, billing_details } = response.data;

        setTransactions(transactions);
        setBillingDetails(billing_details);  // You’ll need a state for this
      } catch (err) {
        setError("Hey, you have not done any transactions yet!");
      } finally {
        setLoading(false);
      }
    };

    fetchTransactionsAndBilling();
  }, [userId]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;



  const handleDownloadInvoice = async (transaction, billingDetails) => {
    const fetchSessionDetails = async (orderId, type) => {
      try {
        const response = await axios.get(`${API_URL}/api/session-details/`, {
          params: { order_id: orderId, type: type },
        });
        return response.data;
      } catch (err) {
        console.error("Session details fetch failed", err);
        return null;
      }
    };

    const session = await fetchSessionDetails(transaction.post_id, transaction.type);
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const date = new Date(transaction.created_at);
    const formattedDate = date.toLocaleDateString();
    const formattedTime = date.toLocaleTimeString();

    // === Watermark ===
    doc.saveGraphicsState();
    doc.setTextColor(220, 220, 220); // light gray
    doc.setFontSize(50);
    doc.setFont("helvetica", "bold");
    doc.text("Anthrasync", pageWidth / 2, pageHeight / 2, {
      angle: 45,
      align: "center",
      opacity: 0.05
    });
    doc.restoreGraphicsState();

    // === Add Watermark: Second Instance (bottom left) ===
    doc.saveGraphicsState();
    doc.setFontSize(40);
    doc.setTextColor(230, 230, 230);
    doc.setFont("helvetica", "bold");
    doc.text("Anthrasync", 30, pageHeight - 30, {
      angle: 25,
      opacity: 0.05
    });
    doc.restoreGraphicsState();

    // === HEADER ===
    // Logo with aspect ratio of 4.5
    const logoWidth = 60; // You can adjust the width
    const logoHeight = logoWidth / 4.5; // Calculate height to maintain aspect ratio
    const logoX = pageWidth - logoWidth - 14; // Right-aligned with some margin
    const logoY = 10; // Top margin

    doc.addImage(Logo, 'PNG', logoX, logoY, logoWidth, logoHeight); // Add the logo to the PDF

    doc.setFontSize(22);
    doc.setTextColor(30, 144, 255); // DodgerBlue
    doc.text("INVOICE", 14, 20);

    doc.setFontSize(12);
    doc.setTextColor(0);
    doc.setFont(undefined, "bold");
    doc.text("Anthrasync Solutions Private Limited", 14, 30);
    doc.setFont(undefined, "normal");
    doc.text("No 26, Laskar Hosur Road, Adugodi, Bangalore South,", 14, 36);
    doc.text("Bengaluru, India - 560030", 14, 42);
    doc.text("Phone: +91 9429693334 | contact@anthrasync.com", 14, 48);

    // GST No (can replace with actual GST number)
    doc.setTextColor(60);
    doc.text("GST No: 29ABBCA0435C1Z8", 14, 54);

    doc.setDrawColor(200);
    doc.line(14, 58, 196, 58);

    // === INVOICE DETAILS ===
    doc.setFontSize(12);
    doc.setTextColor(60);
    doc.text(`Invoice No:`, 14, 62);
    doc.setTextColor(0);
    doc.text(`${transaction.invoice_number || "N/A"}`, 45, 62);

    doc.setTextColor(60);
    doc.text(`Invoice Date:`, 14, 68);
    doc.setTextColor(0);
    doc.text(`${formattedDate}`, 45, 68);

    doc.setTextColor(60);
    doc.text(`Invoice Time:`, 14, 74);
    doc.setTextColor(0);
    doc.text(`${formattedTime}`, 45, 74);

    doc.setTextColor(60);
    doc.text(`Transaction ID:`, 14, 80);
    doc.setTextColor(0);
    doc.text(`${transaction.transaction_id}`, 45, 80);

    doc.setTextColor(60);
    doc.text(`Order ID:`, 14, 86);
    doc.setTextColor(0);
    doc.text(`${transaction.post_id}`, 45, 86);

    let yPos = 96;

    // === BILLING SECTION ===
    doc.setFillColor(230, 240, 255);
    doc.rect(14, yPos, pageWidth - 28, 10, "F");
    doc.setTextColor(0);
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");
    doc.text("BILL TO:", 16, yPos + 7);
    yPos += 14;

    doc.setFontSize(12);
    doc.setFont(undefined, "normal");

    if (billingDetails) {
      const { name, surname, address, city, state, country, pincode, contact } = billingDetails;

      doc.text(`${name || ""} ${surname || ""}`, 14, yPos); yPos += 6;
      if (address) { doc.text(address, 14, yPos); yPos += 6; }
      if (city || state || pincode) {
        doc.text(`${city || ""}, ${state || ""} - ${pincode || ""}`, 14, yPos);
        yPos += 6;
      }
      if (country) { doc.text(country, 14, yPos); yPos += 6; }
      if (contact) { doc.text(`Phone: ${contact}`, 14, yPos); yPos += 6; }
    } else {
      doc.text("User ID: " + transaction.user_id, 14, yPos);
      yPos += 6;
    }

    yPos += 4;
    doc.setDrawColor(200);
    doc.line(14, yPos, 196, yPos);
    yPos += 8;

    // === SESSION DETAILS ===
    if (session) {
      doc.setFillColor(245, 245, 245);
      doc.rect(14, yPos, pageWidth - 28, 10, "F");
      doc.setFontSize(14);
      doc.setFont(undefined, "bold");
      doc.setTextColor(0);
      doc.text("SESSION DETAILS", 16, yPos + 7);
      yPos += 14;

      doc.setFontSize(12);
      doc.setFont(undefined, "normal");

      doc.text(`Description: ${session.description}`, 14, yPos); yPos += 6;
      doc.text(`Date: ${session.session_date}`, 14, yPos); yPos += 6;
      doc.text(`Time: ${session.session_time}`, 14, yPos); yPos += 6;
      doc.text(`Host: ${session.host_name} ${session.host_surname}`, 14, yPos); yPos += 10;

      doc.setDrawColor(200);
      doc.line(14, yPos, 196, yPos);
      yPos += 8;
    }

    // === TRANSACTION SUMMARY ===
    doc.setFontSize(13);
    doc.setFont(undefined, "bold");
    doc.setTextColor(30, 144, 255);
    doc.text("TRANSACTION SUMMARY", 14, yPos);
    yPos += 8;

    doc.setFontSize(12);
    doc.setTextColor(0);
    doc.setFont(undefined, "bold");
    doc.text("Description", 14, yPos);
    doc.text("Type", 120, yPos);
    doc.text("Amount", 170, yPos);
    yPos += 6;

    doc.setFont(undefined, "normal");
    doc.setFontSize(11);
    doc.text(transaction.payment_reason, 14, yPos);
    doc.text(transaction.type || "-", 120, yPos);
    doc.text(`${transaction.amount} INR`, 170, yPos);

    yPos += 14;
    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text("Total Paid:", 14, yPos);
    doc.setFont(undefined, "normal");
    doc.text(`${transaction.amount} INR`, 170, yPos);

    yPos += 8;
    doc.setFont(undefined, "bold");
    doc.text("Status:", 14, yPos);
    doc.setFont(undefined, "normal");
    doc.text(`${transaction.status}`, 170, yPos);

    // === FOOTER ===
    yPos += 20;
    doc.setFontSize(10);
    doc.setTextColor(100);
    doc.text("Thank you for choosing Anthrasync!", 14, yPos);

    // Electronic signature message
    yPos += 6;
    doc.setFontSize(10);
    doc.text("This is an electronically generated invoice and does not require a signature.", 14, yPos);

    // === SAVE PDF ===
    doc.save(`invoice_${transaction.transaction_id}.pdf`);
  };

  return (
    <div>
      <Header1 userId={userId} onLogout={onLogout} />


      <Typography
        variant="h3"
        component="h1"
        align="center"
        fontSize={{ xs: '2rem', sm: '2.5rem', md: '3rem' }}
        sx={{
          backgroundImage: 'linear-gradient(45deg, #00bfff, #ff00ff)',
          mt: 5,
          letterSpacing: 10,
          WebkitBackgroundClip: 'text',  // This makes the gradient clip to the text
          color: 'transparent',  // Makes the text itself transparent to show the gradient
          // fontWeight: 'bold',  // Optional: you can make the text bold
        }}
        gutterBottom
      >
        Transaction History
      </Typography>
      <Box
        sx={{
          padding: { xs: "1rem", sm: "2rem" },
          backgroundColor: "#000000",
          color: "white",
          borderRadius: "12px",
          boxShadow: "0 10px 20px rgba(0, 0, 0, 0.25)",
          ml: { xs: 0, sm: 5, md: 7 },
          mt: 2,
          overflow: "hidden",
          width: "100%",
          maxWidth: { xs: "100%", sm: "90%", md: "80%", lg: "90%" },
        }}
      >
        <TableContainer
          component={Paper}
          sx={{
            backgroundColor: "#000000",
            borderRadius: "10px",
            boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
            width: "100%",
            maxWidth: "100%",
            overflowX: "auto",
            marginBottom: "2rem",
          }}
        >
          <Table sx={{ tableLayout: "auto", width: "100%" }}>
            <TableHead>
              <TableRow>
                {["S No.", "Order ID", "Date", "Time", "Transaction ID", "Type", "Status", "Cost", "Remarks", "View", "Download"].map((header, index) => (
                  <TableCell
                    key={index}
                    sx={{
                      color: "white",
                      backgroundColor: "#2222",
                      fontWeight: "bold",
                      fontSize: { xs: "0.8rem", sm: "1rem" },
                      textTransform: "uppercase",
                      borderBottom: "1.5px solid #5555",
                      textAlign: "center",
                      fontFamily: "'Helvetica', sans-serif",
                      letterSpacing: 3,
                      "&:hover": { color: "#1E90FF", borderColor: "#1E90FF" },
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {transactions.map((transaction, index) => {
                const date = new Date(transaction.created_at);
                const formattedDate = date.toLocaleDateString();
                const formattedTime = date.toLocaleTimeString();

                return (
                  <TableRow key={transaction.id}>
                    <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
                      {index + 1}
                    </TableCell>
                    <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
                      {transaction.post_id}
                    </TableCell>
                    <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
                      {formattedDate}
                    </TableCell>
                    <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
                      {formattedTime}
                    </TableCell>
                    <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
                      {transaction.transaction_id}
                    </TableCell>
                    <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
                      {transaction.type}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: transaction.status === "success" ? "#4caf50" : "#f44336", // green if successful, red otherwise
                        fontWeight: "bold",
                        textAlign: "center",
                        borderBottom: "1.5px solid #5555",
                        letterSpacing: 2,
                      }}
                    >
                      {transaction.status}
                    </TableCell>
                    <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
                      {transaction.amount}
                    </TableCell>
                    <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
                      {transaction.payment_reason}
                    </TableCell>
                    <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
                      {transaction.status === "success" && (
                        <Button variant="outlined" sx={{ color: "#1E90FF", marginRight: "1rem", letterSpacing: 2 }} onClick={() => handleViewInvoice(transaction)}>
                          View Invoice
                        </Button>
                      )}
                    </TableCell>
                    <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
                      {transaction.status === "success" && (
                        <Button
                          variant="outlined"
                          sx={{ color: "#1E90FF", letterSpacing: 2 }}
                          onClick={() => handleDownloadInvoice(transaction, billingDetails)}
                        >
                          Download Invoice
                        </Button>

                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
          <DialogTitle style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
            Invoice Preview
          </DialogTitle>

          <DialogContent
            dividers
            style={{
              fontFamily: 'Arial, sans-serif',
              lineHeight: 1.6,
              backgroundColor: '#ffffff',
              color: '#1a1a1a', // Dark text for contrast
            }}
          >
            {selectedTransaction && (
              <>
                {/* Header */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                  <div>
                    <h2 style={{ color: '#1E90FF', marginBottom: 4 }}>INVOICE</h2>
                    <div style={{ fontWeight: 'bold' }}>Anthrasync Solutions Private Limited</div>
                    <div>No 26, Laskar Hosur Road, Adugodi, Bangalore South,</div>
                    <div>Bengaluru, India - 560030</div>
                    <div>Phone: +91 9429693334 | contact@anthrasync.com</div>
                    <div style={{ color: '#333' }}>GST No: <strong>29ABBCA0435C1Z8</strong></div>
                  </div>
                  <img src={Logo} alt="Logo" style={{ width: 100 }} />
                </div>

                <hr />

                {/* Invoice Details */}
                <div style={{ marginTop: 16 }}>
                  <div><strong>Invoice No:</strong> {selectedTransaction.invoice_number || 'N/A'}</div>
                  <div><strong>Date:</strong> {new Date(selectedTransaction.created_at).toLocaleDateString()}</div>
                  <div><strong>Time:</strong> {new Date(selectedTransaction.created_at).toLocaleTimeString()}</div>
                  <div><strong>Transaction ID:</strong> {selectedTransaction.transaction_id}</div>
                  <div><strong>Order ID:</strong> {selectedTransaction.post_id}</div>
                </div>

                <hr />

                {/* Billing Details */}
                {/* Billing Details */}
                <div style={{ marginTop: 16 }}>
                  <h3 style={{ background: '#e6f0ff', padding: '6px 10px', marginBottom: 8 }}>BILL TO:</h3>

                  <div style={{ color: '#1a1a1a', lineHeight: 1.6 }}>
                    {(billingDetails.name || billingDetails.surname) && (
                      <div>{billingDetails.name || ''} {billingDetails.surname || ''}</div>
                    )}
                    {billingDetails.address && (
                      <div>{billingDetails.address}</div>
                    )}
                    {(billingDetails.city || billingDetails.state || billingDetails.pincode) && (
                      <div>{billingDetails.city || ''}, {billingDetails.state || ''} - {billingDetails.pincode || ''}</div>
                    )}
                    {billingDetails.country && (
                      <div>{billingDetails.country}</div>
                    )}
                    {billingDetails.contact && (
                      <div>Phone: {billingDetails.contact}</div>
                    )}
                  </div>

                </div>


                <hr />

                {/* Session Details */}
                {sessionDetails && (
                  <div style={{ marginTop: 16 }}>
                    <h3 style={{ background: '#f5f5f5', padding: '6px 10px', marginBottom: 8 }}>SESSION DETAILS</h3>
                    <div style={{ color: '#333' }}>
                      {/* <div><strong>Topic:</strong> {sessionDetails.topic_name}</div> */}
                      <div><strong>Description:</strong> {sessionDetails.description}</div>
                      <div><strong>Date:</strong> {sessionDetails.session_date}</div>
                      <div><strong>Time:</strong> {sessionDetails.session_time}</div>
                      <div><strong>Host:</strong> {sessionDetails.host_name} {sessionDetails.host_surname}</div>
                    </div>
                  </div>
                )}

                <hr />

                {/* Transaction Summary */}
                <div style={{ marginTop: 16 }}>
                  <h3 style={{ color: '#1E90FF' }}>TRANSACTION SUMMARY</h3>
                  <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 10, color: '#333' }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'left', borderBottom: '1px solid #ccc', paddingBottom: 6 }}>Description</th>
                        <th style={{ textAlign: 'left', borderBottom: '1px solid #ccc', paddingBottom: 6 }}>Type</th>
                        <th style={{ textAlign: 'right', borderBottom: '1px solid #ccc', paddingBottom: 6 }}>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{selectedTransaction.payment_reason}</td>
                        <td>{selectedTransaction.type || '-'}</td>
                        <td style={{ textAlign: 'right' }}>{selectedTransaction.amount} INR</td>
                      </tr>
                    </tbody>
                  </table>

                  <div style={{ marginTop: 10, display: 'flex', justifyContent: 'space-between', color: '#333' }}>
                    <strong>Total Paid:</strong>
                    <span>{selectedTransaction.amount} INR</span>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'space-between', color: '#333' }}>
                    <strong>Status:</strong>
                    <span>{selectedTransaction.status}</span>
                  </div>
                </div>

                {/* Footer */}
                <div style={{ marginTop: 24, color: '#444', fontSize: 12 }}>
                  <div>Thank you for choosing Anthrasync!</div>
                  <div>This is an electronically generated invoice and does not require a signature.</div>
                </div>
              </>
            )}
          </DialogContent>

          <DialogActions style={{ backgroundColor: '#f5f5f5' }}>
            <Button onClick={handleCloseDialog} color="primary" variant="outlined">Close</Button>
          </DialogActions>
        </Dialog>

      </Box>
      <Footer2 />

    </div>
  );
}

export default PaymentDetails;
